<script module>
  import DOMPurify from "dompurify";
  import SystemBannerNotification from "./SystemBannerNotification.svelte";
  import { withDataSwDs } from "../../../utils/segmentation";

  let count = 0;
  const generateId = () => {
    const id = `system-banner-notification-${count}`;
    count += 1;
    return id;
  };

  let notificationsState = $state([]);
  const addNotification = ({ props = {}, content = "", timeout = null }) => {
    const { id = generateId() } = props;
    count += 1;
    notificationsState = [
      { props: { ...props, id }, content },
      ...notificationsState,
    ];
    if (timeout) {
      setTimeout(() => {
        notificationsState = notificationsState.filter(
          (notification) => notification.props.id !== id
        );
      }, timeout);
    }
  };

  export { notifications, addNotification };
</script>

{#snippet notifications()}
  {#each notificationsState as { props, content }}
    <SystemBannerNotification {...props}>
      {#if content && typeof content === "function"}
        {@render content()}
      {:else}
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        {@html DOMPurify.sanitize(withDataSwDs(content))}
      {/if}
    </SystemBannerNotification>
  {/each}
{/snippet}
